import ApiService from "../../../services/ApiService";
import Logger from "../../../services/Logger";

const StripeService = {
    /**
     * Send a test Stripe webhook event to the server
     * @param {Object} webhookData - Stripe webhook event data
     * @returns {Promise<Object>} API response
     */
    sendTestWebhook: async (webhookData) => {
        try {
            const result = await ApiService.postData("/test/stripe-webhook", webhookData);
            
            if (result && result.code === "FAILURE") {
                throw new Error(result.message || "Failed to send Stripe webhook");
            }
            
            return result;
        } catch (error) {
            Logger.error("Error sending Stripe webhook:", error);
            throw error;
        }
    }
};

export default StripeService;

